/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
export const OPACITY_ACTIVE = 1.;
export const OPACITY_INACTIVE = .4;
export const OPACITY_LINE = 1;
export const OPACITY_ARC = .43;
export const OPACITY_HIDDEN = .000001;
export const ARROW_LENGTH = 1.0;
export const EDITOR_SCREEN_SIZE_PX = 100;
export const AXIS_REF_LINE_LENGTH = 10000;
export const RED = 0xe04040;
export const GREEN = 0x60e040;
export const BLUE = 0x1050f0;
export const YELLOW = 0xe0e060;
export const BLACK = 0x000000;
export const WHITE = 0xffffff;
export const SHAPE_EDITOR_TYPE_NAME = 'AxisEditor';
export const DEFAULT_SHAPE_EDITOR_NAME = 'shapeEditor';
export const DEFAULT_CAMERA_NAME = 'default';
//# sourceMappingURL=constants.js.map